/* 
  How to use me?

  <app-date-picker [model]="model" [fieldName]="field.name"></app-date-picker>

  model - should be an object
  fieldName - will be the expected property to be modified

  styles - you can update it depends on required UI
 */

import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl";
import * as moment from 'moment';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  styles: [`
    :host {
      position: relative;
      border-bottom: 1px solid #ccc;
      font-size: 18px;  
      width: 100%;
      padding: 12px 9px;
    }
  `]
})
export class DatePickerComponent implements OnInit {
  @ViewChild('inputRef', { read: ElementRef })  inputRef: ElementRef;
  @Input() model  = {}; //Inherited from parent component
  @Input() fieldName: string  = ''; //Field property name from parent
  @Input() maxDate: string  =  `${moment().year()}`; //Current year will be the default if no value passed

  dateValue = '';
  picker = null;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if(this.model[this.fieldName] && this.picker) { 
      //Check field if there is a change in value - this will trigger specially when getting the value from database
      this.dateValue = flatpickr.formatDate(new Date(this.model[this.fieldName]), 'd-m-Y');
      this.picker.setDate(this.dateValue);
    }
  }

  ngAfterViewInit(): void { 
    this.picker = flatpickr(this.inputRef.nativeElement, {
      locale: Dutch,
      dateFormat: 'd-m-Y',
      maxDate: `31-12-${this.maxDate}`,
      onChange: (selectedDate, dateStr) => {
        this.model[this.fieldName] = dateStr;
      }
    });
    
    if(this.model[this.fieldName]){
      //Check field if there is a value already - it will trigger once specially when getting the value from store or localstorage
      this.dateValue = flatpickr.formatDate(new Date(this.model[this.fieldName]), 'd-m-Y');
      this.picker.setDate(this.dateValue);
    }
  }

  ngOnDestroy() {
    this.picker.destroy();
  }

}
